// `dataJson` é a mensagem crua do WhatsApp guardada pelo servidor. Pode chegar como texto
// JSON, já como objeto, vazio ou truncado/inválido — ler nunca pode quebrar a conversa.

const cache = new WeakMap();

export const parseDataJson = (message) => {
  if (!message || typeof message !== "object") return null;
  if (cache.has(message)) return cache.get(message);
  let parsed = null;
  const raw = message.dataJson;
  if (raw && typeof raw === "object") {
    parsed = raw;
  } else if (typeof raw === "string" && raw.length > 1) {
    try {
      const value = JSON.parse(raw);
      parsed = value && typeof value === "object" ? value : null;
    } catch (e) {
      parsed = null;
    }
  }
  cache.set(message, parsed);
  return parsed;
};

const WRAPPERS = [
  "ephemeralMessage",
  "viewOnceMessage",
  "viewOnceMessageV2",
  "viewOnceMessageV2Extension",
  "documentWithCaptionMessage",
  "editedMessage",
];

// Conteúdo da mensagem do WhatsApp, por baixo dos envelopes (temporária, visualização única…).
export const waContentOf = (message) => {
  const data = parseDataJson(message);
  let content = data && data.message && typeof data.message === "object" ? data.message : null;
  for (let depth = 0; content && depth < 4; depth += 1) {
    const wrapper = WRAPPERS.find((key) => content[key] && typeof content[key].message === "object" && content[key].message);
    if (!wrapper) break;
    content = content[wrapper].message;
  }
  return content;
};
